import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";

import {
  containerStyles,
  subTitleStyles,
  titleStyles,
} from "./styles/Header.styles";
import { Button, Flex } from "@twilio-paste/core";
import "./styles/header.module.css";
import { useDispatch } from "react-redux";
import { changeExpandedStatus } from "../store/actions/genericActions";

export const Header = ({ customTitle }: { customTitle?: string }) => {
  const dispatch = useDispatch();
  return (
    <Box as="header" {...containerStyles}>
      <Flex
        vAlignContent="center"
        marginX="space40"
        width="90%"
        hAlignContent="between"
      >
        <Flex vAlignContent="center">
          <div style={{ position: "relative", width: "30px", marginRight: 5 }}>
            <img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iMTYiIGZpbGw9IiNmZmYiLz4KPG1hc2sgaWQ9ImEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+CjxyZWN0IHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgcng9IjE2IiBmaWxsPSIjZmZmIi8+CjwvbWFzaz4KPHBhdGggZD0iTTE3LjIgOGgtMy44Yy0uNCAwLS44LjMtMSAuN2wtMiA3Yy0uMi43LjMgMS4zLjkgMS4zSDE1bC0xLjUgNyA3LjMtOS40Yy41LS42IDAtMS42LS44LTEuNmgtM2wxLjEtMy43Yy4yLS43LS4zLTEuMy0uOS0xLjN6IiBmaWxsPSIjMjE1NjgyIi8+Cjwvc3ZnPgo="
              alt=""
            ></img>
            <span
              style={{
                position: "absolute",
                width: "7px",
                height: "7px",
                borderRadius: "50%",
                backgroundColor: "#12b886",
                bottom: "5px",
                right: 0,
                outline: "#215682 solid 2px",
              }}
            ></span>
          </div>
          <Flex vertical>
            <Text as="h2" {...titleStyles}>
              Assistente Virtuale
            </Text>
            <Text as="h6" {...subTitleStyles}>
              Risponde istantaneamente
            </Text>
          </Flex>
        </Flex>
        <Button variant="link" onClick={() => dispatch(changeExpandedStatus({ expanded: false }))}>
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 1.5L10.5 0 6 4.5 1.5 0 0 1.5 4.5 6 0 10.5 1.5 12 6 7.5l4.5 4.5 1.5-1.5L7.5 6 12 1.5z"
              fill="white"
            ></path>
          </svg>
        </Button>
      </Flex>
    </Box>
  );
};
